import React from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'

const reload=()=>window.location.reload()

const GET_DELETE_QUERY = gql`
  mutation DeleteQuery($input: DeleteFileInput!) {
    deleteFile(input: $input) {
      id
    }
  }
`
export default function DeleteFileModal(props) {
  const [ deleteFile ] = useMutation(
    GET_DELETE_QUERY,
    {
      variables: {
        input: {
          cuid: props.row.cuid,
          key: props.itemId + '/'+ props.row.name
        }
      }
    }
  )

  return (
    <Modal {...props} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Delete File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit= {e => {
            e.preventDefault()
            deleteFile().then(              
              result => {
                window.location.reload()
              },
              error => {
                console.log('Delete file failed with error: ', error)
                props.onHide()
              }
            )
            props.onHide()
          }}
        >
          <h3>You are about to delete a file: {props.row.name}</h3>
          <br/>
          <p>Your file will be deleted from this item.</p>
          <Modal.Footer>
            <Button variant='secondary' onClick={props.onHide}>Close</Button>
            <Button variant='primary' type='submit'>Delete File</Button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

DeleteFileModal.propTypes = {
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string
  }),
  onHide: PropTypes.func,
  itemId: PropTypes.string,
}
